export const Industries = [
  { label: "Advertising / Marketing", value: "advertising_marketing" },
  { label: "Agriculture", value: "agriculture" },
  { label: "Architecture / Interior Design", value: "architecture_interior_design" },
  { label: "Automobile", value: "automobile" },
  { label: "Aviation", value: "aviation" },
  { label: "Banking/Insurance", value: "banking_insurance" },
  { label: "BPO / Call Centre", value: "bpo_call_centre" },
  { label: "Consultation services", value: "consultation_services" },
  { label: "Courier / Logistics", value: "courier_logistics" },
  { label: "Education", value: "education" },
  { label: "Entertainment", value: "entertainment" },
  { label: "Financial Services", value: "financial_services" },
  { label: "Government", value: "government" },
  { label: "Hospitality", value: "hospitality" },
  { label: "Import / Export", value: "import_export" },
  { label: "IT (Information Technology)", value: "it" },
  { label: "Jewellery", value: "jewellery" },
  { label: "Legal services", value: "legal_services" },
  { label: "Manufacturing / Processing", value: "manufacturing_processing" },
  { label: "Media / News", value: "media_news" },
  { label: "Medical / Pharmaceutical", value: "medical_pharmaceutical" },
  { label: "Mining", value: "mining" },
  { label: "Oil / Gas / Power", value: "oil_gas_power" },
  { label: "Printing / Publishing", value: "printing_publishing" },
  { label: "Railways", value: "railways" },
  { label: "Real Estate", value: "real_estate" },
  { label: "Recruitment / Staffing", value: "recruitment_staffing" },
  { label: "Retail", value: "retail" },
  { label: "Security / Law Enforcement", value: "security_law_enforcement" },
  { label: "Textile", value: "textile" },
  { label: "Travel / Tourism", value: "travel_tourism" },
  { label: "Warehousing / Wholesale", value: "warehousing_wholesale" },
];
